import ProductTypeSelect from './ProductTypeSelect'

export default ProductTypeSelect
